import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
import { FretDivider } from './components/Ornaments';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-6 text-center" data-id="element-0" data-mp="31c1iue7j1yhb">
    <FretDivider character="次" data-id="element-1" data-mp="2wjqkvgwckmre" />
    <p className="mt-4 font-display text-xl font-bold italic leading-relaxed text-brand-cinnabar/90 md:text-3xl" data-id="element-2" data-mp="2wip54z4dzc3c">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="rice-paper min-h-screen font-sans text-brand-text selection:bg-brand-cinnabar/20 selection:text-brand-cinnabarDark" data-id="element-3" data-mp="23t8ea5wf0398">
      <UrgencyBanner data-id="element-4" data-mp="3ml1234bj9ggw" />
      <Hero data-id="element-5" data-mp="3mk8710lxsfel" />
      <PackContents data-id="element-6" data-mp="3mjztr7lwj82v" />
      <InitialTestimonials data-id="element-7" data-mp="3mjgclt42snpw" />
      <PainPoints data-id="element-8" data-mp="3rcj2nr9n9f1c" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-9" data-mp="3rdaqgfx028h2">
        <Pricing data-id="element-10" data-mp="5otf64sd496" />
      </div>
      <MoreTestimonials data-id="element-11" data-mp="4wupmfw6qeo" />
      <FAQ data-id="element-12" data-mp="56nfhsbnbo2" />
      <TransitionPhrase data-id="element-13" data-mp="82k72sfnuax" />
      <EmotionalClose data-id="element-14" data-mp="2zld0z6e9z99y" />
      <Footer data-id="element-15" data-mp="2zlv8x0aavbxp" />
      <FloatingNotification data-id="element-16" data-mp="2zmeoiach9o8k" />
    </div>;
}